import React, { useRef } from "react";
import ArrowTop from "../../../Common/svg/arrowtop";
import { useQuery } from "react-query";
import { getVehicles } from "../../../../MyApi/vehicles";
import { toast } from "react-toastify";

const VehicleInfo = ({ vehicle, setVehicle ,setCuriorInfo,curiorInfo ,formErrors }) => {
  const { data, isLoading } = useQuery("getVehicles", getVehicles);
  const vehicles = data?.data?.vehicles || [];

  const driverLicenseRef = useRef(null);
  const carLicenseRef = useRef(null);
const imageInstructions = {
  maxSize: "12MB",
  formats: "JPG, PNG, JPEG, GIF, WEBP",
};


const validateImage = (file) => {
  const maxSize = 12 * 1024 * 1024; // 12MB
  const validTypes = [
    "image/jpeg",
    "image/png",
    "image/jpg",
    "image/gif",
    "image/webp",
  ];

  if (!file) return false;

  if (file.size > maxSize) {
    toast.error("حجم الملف يجب ألا يتجاوز 12 ميجابايت");
    return false;
  }

  if (!validTypes.includes(file.type)) {
    toast.error("نوع الملف غير مدعوم. المسموح: JPG, PNG, GIF, WEBP");
    return false;
  }

  return true;
};
  return (
    <div className="row gy-3">
      <h6 className="font16 mb-2">تفاصيل المركبة</h6>

      {/* نوع المركبة */}
      <div className="col-12">
        <h6>نوع المركبة</h6>
        <select
          className="form-select"
          value={vehicle.vehicle_id}
          onChange={(e) =>
            setVehicle((prev) => ({ ...prev, vehicle_id: e.target.value }))
          }
        >
          <option value="">اختر المركبة</option>
          {isLoading ? (
            <option>جاري التحميل...</option>
          ) : (
            vehicles.map((v) => (
              <option key={v.id} value={v.id}>
                {v.name}
              </option>
            ))
          )}
        </select>
      </div>  

      {/* الموديل */}
      <div className="col-12">
        <label  className="form-label font16">الموديل</label>
        <input
          type="text"
          className="form-control"
          placeholder="أدخل الموديل"
          value={vehicle.model}
          onChange={(e) =>
            setVehicle((prev) => ({ ...prev, model: e.target.value }))
          }
        />
      </div>

      {/* رقم اللوحة */}
      <div className="col-md-6">
        <label className="form-label">رقم اللوحة</label>
        <input
          type="text"
          className="form-control"
          placeholder="أدخل رقم اللوحة"
          value={vehicle.plate_number}
          onChange={(e) =>
            setVehicle((prev) => ({ ...prev, plate_number: e.target.value }))
          }
        />
      </div>

      {/* اللون */}
      <div className="col-md-6">
        <label className="form-label">اللون</label>
        <input
          type="text"
          className="form-control"  
          placeholder="أدخل اللون"
          value={vehicle.color}
          onChange={(e) =>
            setVehicle((prev) => ({ ...prev, color: e.target.value }))
          }
        />
      </div>
      <h5 className="fs-5 mt-3">
تعليمات  رفع الصورة
      </h5>
<div className="small text-muted mt-2">
  <div className="fw-bold">📷 الصيغ المسموحة: {imageInstructions.formats}</div>
  <div className="fw-bold">💾 الحد الأقصى للحجم: {imageInstructions.maxSize}</div>
 
</div>
      {/* صورة رخصة القيادة */}
      <div className="col-md-6">
        <label className="form-label">صورة رخصة القيادة</label>
        <div
          className={`flex-grow-1 border  rounded-4 text-center p-4 upload-box ${ formErrors.driving_license ? "d-block invalid-feedback ":" "}`}
          style={{ cursor: "pointer", minWidth: "250px" }}
          onClick={() => driverLicenseRef.current?.click()}
        >
          <ArrowTop />
          <h6 className="fw-bold mb-1">صورة رخصة القيادة</h6>
          <p className="text-muted small">(JPG / PNG) ارفع صورة بجودة عالية</p>
          <p className="text-muted small">الأبعاد 1:1</p>

          <input
            type="file"
            accept="image/png, image/jpeg"
            hidden
            ref={driverLicenseRef}
       onChange={(e) => {
  const file = e.target.files[0];

  if (!validateImage(file)) return;

  setCuriorInfo((prev) => ({
    ...prev,
    driving_license: file,
  }));
}}
          />
          {formErrors.driving_license && <small className="d-block invalid-feedback">{formErrors.driving_license}</small>}
                   {    curiorInfo.driving_license && <img  width={50} height={50} src={ curiorInfo.driving_license  instanceof File ? URL.createObjectURL( curiorInfo.driving_license ) : curiorInfo.driving_license } />}
        </div>
      
      </div>

      {/* صورة رخصة المركبة */}
      <div className="col-md-6">
        <label className="form-label">صورة رخصة المركبة</label>
        <div
          className="flex-grow-1 border rounded-4 text-center p-4 upload-box"
          style={{ cursor: "pointer", minWidth: "250px" }}
          onClick={() => carLicenseRef.current?.click()}
        >
          <ArrowTop />
          <h6 className="fw-bold mb-1">صورة رخصة المركبة</h6>
          <p className="text-muted small">(JPG / PNG) ارفع صورة بجودة عالية</p>
          <p className="text-muted small">الأبعاد 1:1</p>

          <input
            type="file"
            accept="image/png, image/jpeg"
            hidden
            ref={carLicenseRef}

               onChange={(e) => {
  const file = e.target.files[0];

  if (!validateImage(file)) return;

  setVehicle((prev) => ({
    ...prev,
    car_license: file,
  }));
}}
          />

           {    vehicle.car_license && <img  width={50} height={50} src={vehicle.car_license instanceof File ? URL.createObjectURL(vehicle.car_license) :vehicle.car_license} />}
              {formErrors.car_license && <small className="d-block invalid-feedback">{formErrors.car_license}</small>}
        </div>

      </div>
    </div>
  );
};

export default VehicleInfo;
